// UpdateUser.jsx
import React, { useState, useEffect, useCallback } from "react";
import { doc, getDoc, updateDoc, getFirestore } from "firebase/firestore";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { refreshHostNameOnEvents } from "../utils/events";

import "../CSS/App.css";

const UpdateUser = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [userId, setUserId] = useState(null);
  const [email, setEmail] = useState("");
  const db = getFirestore();
  const navigate = useNavigate(); // Initialize navigation

  const fetchUserData = useCallback(
    async (userId) => {
      try {
        const userRef = doc(db, "users", userId);
        const userSnap = await getDoc(userRef);
        if (userSnap.exists()) {
          const userData = userSnap.data();
          setFirstName(userData.firstName || "");
          setLastName(userData.lastName || "");
          setEmail(userData.email || "");
        } else {
          console.log("No such document!");
        }
      } catch (error) {
        console.error("Error fetching user data: ", error);
      }
    },
    [db],
  );

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUserId(user.uid);
        // Fetch user data if needed
        fetchUserData(user.uid);
      } else {
        setUserId(null);
      }
    });
    return () => unsubscribe();
  }, [fetchUserData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!userId) {
      console.error("No user is logged in.");
      return;
    }
    try {
      const userRef = doc(db, "users", userId);
      await updateDoc(userRef, {
        firstName,
        lastName,
      });
      console.log(`Updated Name: ${firstName} ${lastName}`);
      // Push the new name onto this host's active events so guests stop seeing
      // the old "Hosted by <name>". Same fallback order as createEvent.
      const hostName =
        [firstName, lastName].filter(Boolean).join(" ").trim() ||
        email ||
        "A friend";
      await refreshHostNameOnEvents(userId, hostName);
      navigate("/");
    } catch (error) {
      console.error("Error updating user information: ", error);
    }
  };

  const handleCancel = () => {
    navigate("/"); // Navigate back to the main page
  };

  return (
    <div
      className="container"
      style={{
        width: "80%",
        maxWidth: "400px",
        margin: "auto",
        paddingTop: "calc(20px + env(safe-area-inset-top, 0px))",
      }}
    >
      <h2>Update User information</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label
            htmlFor="firstName"
            style={{ display: "block", marginBottom: "5px" }}
          >
            First Name
          </label>
          <input
            type="text"
            id="firstName"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            required
            style={{
              width: "90%",
              padding: "10px 15px",
              marginBottom: "10px",
              borderRadius: "20px",
              border: "1px solid var(--border-color, #ccc)",
            }}
          />
        </div>
        <div className="form-group">
          <label
            htmlFor="lastName"
            style={{ display: "block", marginBottom: "5px" }}
          >
            Last Name
          </label>
          <input
            type="text"
            id="lastName"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            required
            style={{
              width: "90%",
              padding: "10px 15px",
              marginBottom: "10px",
              borderRadius: "20px",
              border: "1px solid var(--border-color, #ccc)",
            }}
          />
        </div>
        <div className="form-group">
          <label
            htmlFor="email"
            style={{ display: "block", marginBottom: "5px" }}
          >
            Email
          </label>
          <input
            type="email"
            id="email"
            disabled
            value={email}
            style={{
              width: "90%",
              padding: "10px 15px",
              marginBottom: "10px",
              borderRadius: "20px",
              border: "1px solid var(--border-color, #ccc)",
              color: "var(--text-disabled, #6c757d)",
              backgroundColor: "var(--input-bg-disabled, #f0f0f0)",
            }}
          />
        </div>
        <button
          type="submit"
          className="update-button"
          style={{
            padding: "10px 30px",
            border: "none",
            cursor: "pointer",
            borderRadius: "5px",
            backgroundColor: "#4CAF50",
            color: "white",
            marginRight: "20px",
          }}
        >
          Update
        </button>
        <button
          type="button"
          onClick={handleCancel}
          style={{
            backgroundColor: "gray",
            color: "white",
            padding: "10px 15px",
            border: "none",
            cursor: "pointer",
            borderRadius: "5px",
          }}
        >
          Cancel
        </button>
      </form>
    </div>
  );
};

export default UpdateUser;
